import successSave from "../../assets/sounds/success-save.mp3";
import successDelete from "../../assets/sounds/success-delete.wav";

export const playSuccessSave = () => {
	const audio = new Audio(successSave);
	audio.volume = 0.4; // adjust as needed (0 to 1)
	audio.play();
};

export const playDelete = () => {
	const audio = new Audio(successDelete);
	audio.volume = 0.4; // adjust as needed (0 to 1)
	audio.play();
};
